<template>
	<div class="widget-card">
		<h2 v-if="widget" class="text-center">{{ widget.dashboardwidgets_title }}</h2>

		<LoadingSpinner v-if="loading" />
		<template v-else>
			<table class="table table-sm table-bordered">
				<thead>
					<tr>
						<th>{{ $t('cards.widget.repro_actes_type') }}</th>
						<th>{{ $t('cards.widget.repro_actes_count') }}</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>{{ $t('cards.widget.repro_actes_echographies') }}</td>
						<td class="text-center">{{ echographies }}</td>
					</tr>
					<tr>
						<td>{{ $t('cards.widget.repro_actes_ovulations') }}</td>
						<td class="text-center">{{ ovulations }}</td>
					</tr>
				</tbody>
			</table>
			<p class="text-center mb-0">{{ $t('cards.widget.repro_actes_juments_actives') }} : {{ juments_actives }}</p>
		</template>
	</div>
</template>

<script type="text/javascript">
import DashboardMixin from '@/mixins/Dashboard.js'

export default {
	name: 'WidgetReproActes',
	mixins: [DashboardMixin],
	props: ['widget'],
	data() {
		return {
			loading: true,
			echographies: 0,
			ovulations: 0,
			juments_actives: 0,
		}
	},

	mounted() {
		this.loadData()
	},

	methods: {
		async loadData() {
			this.loading = true
			const res = await this.getReproActesStats()
			this.echographies = res.echographies
			this.ovulations = res.ovulations
			this.juments_actives = res.juments_actives
			this.loading = false
		},
	},

	components: {
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
	},
}
</script>
